import { useEffect, useState } from 'react';

export function useListResponseFormatted(isWeek, isHours, listResponse) {
	const [list, setList] = useState(null);


	useEffect(() => {
		if (listResponse === null) return;
		const filter = (i) => {
			const currentDay = new Date();
			const iterableDay = new Date(i.dt * 1000);

			if (
				(isHours && currentDay.getDate() === iterableDay.getDate()) ||
				currentDay.getDate() + 1 === iterableDay.getDate()
			)
				return true;
			if ((isWeek) && (currentDay.getDate() !== iterableDay.getDate())) return true;
			return false;
		};

		setList(
			isWeek
				? listResponse
						.filter(filter)
						.filter((n, i, a) => n === a.find((m) => m.dt_txt.split(' ')[0] === n.dt_txt.split(' ')[0]))
				: isHours
				? listResponse.filter(filter).slice(0, 8)
				: null
		);
	}, [isHours, isWeek, listResponse]);
  if (typeof listResponse === "undefined") return [null];
	return [list];
}
